import React, { useState } from "react";

function Monitoring({ messages, publishedMessages }) {
  const [selectedDevice, setSelectedDevice] = useState("");

  // Helper to extract deviceId from a topic
  const extractDeviceId = (topic) => {
    if (!topic) return null;
    const parts = topic.split("/");
    return parts[1] === "arosia" ? parts[2] : null;
  };

  // Extract unique deviceIds from all messages
  const allDeviceIds = Array.from(
    new Set(
      [...messages, ...publishedMessages]
        .map((msg) => extractDeviceId(msg.topic))
        .filter(Boolean)
    )
  );

  // Filter logic using deviceId instead of topic equality
  const filteredMessages = selectedDevice
    ? messages.filter((msg) => extractDeviceId(msg.topic) === selectedDevice)
    : messages.filter((msg) => extractDeviceId(msg.topic));

  const filteredPublishedMessages = selectedDevice
    ? publishedMessages.filter(
        (msg) => extractDeviceId(msg.topic) === selectedDevice
      )
    : publishedMessages.filter((msg) => extractDeviceId(msg.topic));

  // ✅ Custom formatted date-time in 24-hour format
  const formatTime = (timestamp) => {
    if (!timestamp) return "";
    const date = new Date(timestamp);
    return date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>📡 Real-time Monitoring</h1>

      {/* Device Dropdown */}
      <select
        value={selectedDevice}
        onChange={(e) => setSelectedDevice(e.target.value)}
        style={styles.dropdown}
      >
        <option value="">All Devices</option>
        {allDeviceIds.map((deviceId, index) => (
          <option key={index} value={deviceId}>
            {deviceId}
          </option>
        ))}
      </select>

      <div style={styles.columns}>
        {/* Incoming MQTT */}
        <div style={styles.column}>
          <h2 style={styles.subheading}>📥 Incoming MQTT Messages</h2>
          {filteredMessages.length > 0 ? (
            filteredMessages.map((msg, index) => (
              <div key={index} style={styles.messageCard}>
                <strong style={styles.topic}>{msg.topic}</strong>
                <p style={styles.message}>{msg.message}</p>
                <p style={styles.timestamp}>⏱ {formatTime(msg.timestamp)}</p>
              </div>
            ))
          ) : (
            <p style={styles.noData}>No incoming messages...</p>
          )}
        </div>

        {/* Published */}
        <div style={styles.column}>
          <h2 style={styles.subheading}>📤 Published Messages</h2>
          {filteredPublishedMessages.length > 0 ? (
            filteredPublishedMessages.map((msg, index) => (
              <div
                key={index}
                style={{ ...styles.messageCard, background: "#e8f5e9" }}
              >
                <strong style={{ ...styles.topic, color: "#2e7d32" }}>
                  {msg.topic}
                </strong>
                <p style={styles.message}>{msg.message}</p>
                <p style={styles.timestamp}>⏱ {formatTime(msg.timestamp)}</p>
              </div>
            ))
          ) : (
            <p style={styles.noData}>No published messages...</p>
          )}
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    width: "95%",
    margin: "auto",
    textAlign: "center",
    padding: "20px",
    background: "#f9f9f9",
    borderRadius: "10px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  },
  heading: {
    fontSize: "24px",
    color: "#333",
    marginBottom: "20px",
  },
  dropdown: {
    padding: "8px",
    fontSize: "16px",
    marginBottom: "25px",
    borderRadius: "5px",
    border: "1px solid #ccc",
  },
  columns: {
    display: "flex",
    gap: "20px",
    justifyContent: "space-between",
    alignItems: "flex-start",
    flexWrap: "wrap",
  },
  column: {
    flex: 1,
    minWidth: "300px",
    maxHeight: "500px",
    overflowY: "auto",
    background: "#fff",
    padding: "15px",
    borderRadius: "10px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
  },
  subheading: {
    fontSize: "20px",
    marginBottom: "10px",
    color: "#444",
    borderBottom: "1px solid #ddd",
    paddingBottom: "5px",
  },
  messageCard: {
    background: "white",
    padding: "10px",
    borderRadius: "6px",
    marginBottom: "10px",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
    textAlign: "left",
  },
  topic: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "#007bff",
  },
  message: {
    fontSize: "14px",
    color: "#333",
    marginTop: "4px",
  },
  timestamp: {
    fontSize: "12px",
    color: "#888",
    marginTop: "4px",
  },
  noData: {
    fontSize: "14px",
    color: "#999",
  },
};

export default Monitoring;
